import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Grid,
  Image,
  Input,
  Label,
  Modal,
  Segment,
  Select,
  Icon,
} from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import {
  addSavedLocationToEmployer,
  fetchEmployerSavedLocations,
  listenToDocFromFirestore,
  logErrorInFirestore,
  promoteJob,
  setJobLocationDetails,
  setJobListedLocationDetails,
} from "../../../app/firestore/firestoreService";
import useFirestoreDoc from "../../../app/hooks/useFirestoreDoc";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from "../../../app/async/asyncReducer";
import { getJobIndustry } from "../../jobs/helpers/jobIndustries";
import { Redirect } from "react-router-dom";
import UxToggle from "../../../app/common/components/UxToggle";
import { SEMANTIC_DIV } from "../../../css/styles";
import { Form, Formik } from "formik";
import MyTextInput from "../../../app/common/form/MyTextInput";
import {
  ADMIN_REVIEW_LOCATION_VALIDATION_SCHEMA,
  ADMIN_REVIEW_LISTED_LOCATION_VALIDATION_SCHEMA,
} from "../../../js/constants/validationSchemas";
import isEqual from "lodash/isEqual";
import MyKeywordTagInput from "../../../app/common/form/MyKeywordTagInput";
import {
  FIRESTORE_JOBS_COLLECTION,
  FIRESTORE_USERS_COLLECTION,
  LOG_ERROR_CODES,
  QUERY_CODES,
} from "../../../app/firestore/firestoreConstants";
import { format } from "date-fns";
import { ADMIN_NOTE } from "../../../js/helpers/map/geolocationDetailsExtractor";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import RecruiterTag from "../../employer/components/RecruiterTag";
import useFirestoreCollection from "../../../app/hooks/useFirestoreCollection";
import isLocationValidForApproval, {
  checkJobLocation,
} from "../helpers/isLocationValidForApproval";
import { PAYMENT_JOB_POST_SERVICE } from "../../payments/paymentConstants";
import { isDescriptionCountValid } from "../../employer/helpers/validateJobFormDetails";
import { fetchCustomerDetails } from "../../employer/employerActions";
import {
  isJobFeatured,
  isJobSponsored,
} from "../../jobs/helpers/checkJobPromotions";
import { reviewService } from "../../../app/api/adminAPI";
import MySingleFieldInput, {
  SINGLE_INPUT_NUMBER_TYPE,
} from "../../../app/common/form/MySingleFieldInput";
import { getHealthcareCategory } from "../../modes/healthcare/jobHealthcareCategories";
import { HR_ALL_MODE, HR_HEALTHCARE_MODE } from "../../modes/constants";
import { checkToUpdateMultiLocJobs } from "../../../js/helpers/multipleJobLocationHelpers";
import { PHARMA_SHIFT } from "../../candidates/components/JobAlertsPane";

const DROP_DOWN_JOB_ALERTS = [
  { key: 1, text: "N/A", value: "General" },
  { key: 2, text: "Urgent Shift - pharma", value: PHARMA_SHIFT },
];

export default function AdminJobReviewModal({ job }) {
  const dispatch = useDispatch();

  const { loading, error } = useSelector((state) => state.async);

  const [isApprovingAction, setIsApprovingAction] = useState(false);
  const [employerDetails, setEmployerDetails] = useState(null);
  const [isLocationLocked, setIsLocationLocked] = useState(true);
  const [isListedLocationLocked, setIsListedLocationLocked] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [employerSavedLocations, setEmployerSavedLocations] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [promoteDays, setPromoteDays] = useState(0);
  const [isPromoteLocked, setIsPromoteLocked] = useState(true);
  const [reviewStatus, setReviewStatus] = useState([]);
  const [dailyNotificationType, setDailyNotificationType] = useState(null);

  console.log("job", job);
  console.log("selected job", selectedJob);
  console.log("employer", employerDetails);

  useFirestoreDoc({
    query: () =>
      listenToDocFromFirestore({
        dbCollection: FIRESTORE_USERS_COLLECTION,
        id: job.employerId,
      }),
    data: (details) => setEmployerDetails(details),
    deps: [job.employerId],
    queryCode: QUERY_CODES.getUserAccount,
  });

  useFirestoreDoc({
    query: () =>
      listenToDocFromFirestore({
        dbCollection: FIRESTORE_JOBS_COLLECTION,
        id: job.id,
      }),
    data: (selectedJob) => setSelectedJob(selectedJob),
    deps: [job.id, dispatch],
    queryCode: QUERY_CODES.listenToJobFromFirestore,
  });

  useFirestoreCollection({
    shouldExecute: employerDetails,
    query: () => fetchEmployerSavedLocations(employerDetails.id),
    data: (locations) => setEmployerSavedLocations(locations),
    deps: [employerDetails],
  });

  const isDescriptionValid =
    selectedJob && isDescriptionCountValid(selectedJob.description || "");

  async function handleSaveLocation() {
    try {
      setIsLoading(true);
      await addSavedLocationToEmployer({
        employerId: employerDetails.id,
        savedLocation: selectedJob.location,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  async function handlePromoteJob(type) {
    try {
      setIsLoading(true);
      await promoteJob({
        job: selectedJob,
        days: promoteDays,
        promotionType: type,
      });
      await checkToUpdateMultiLocJobs({ job, email: "" });
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
      setIsPromoteLocked(true);
    }
  }

  if (!selectedJob || !employerDetails) return <LoadingComponent />;
  if (error) return <Redirect to="/error" />;

  const isLocationSaved =
    selectedJob.locationType === "Remote"
      ? false
      : employerSavedLocations.filter(
          (location) => selectedJob.location.address === location.address
        ).length > 0;

  const isSubscription = true;

  const isCompanyId = job.companyId === employerDetails.companyId;

  async function handleToggleButton() {
    try {
      setIsApprovingAction(true);
      dispatch(asyncActionStart());
      const response = await reviewService({
        service: PAYMENT_JOB_POST_SERVICE,
        id: selectedJob.id,
        dailyNotificationType:
          !selectedJob.isInitialised && dailyNotificationType !== "General"
            ? dailyNotificationType
            : null,
      });
      setReviewStatus(response.body);
    } catch (e) {
      console.log(e);
      await logErrorInFirestore({
        error: e.toString(),
        errorCode: LOG_ERROR_CODES.adminReviewJob,
        errorPage: "Admin job review job modal - toggle",
        notes: {
          employerId: employerDetails.id,
          jobId: selectedJob.id,
          jobRefNumber: selectedJob.refNumber,
          jobIsInitialised: selectedJob.isInitialised,
          step: "Review job toggle",
        },
      });
      dispatch(
        asyncActionError({
          code: "approve-job-error",
          message: "Could not approve job",
        })
      );
    } finally {
      dispatch(asyncActionFinish());
      setIsApprovingAction(false);
    }
  }

  const { isRemote, isLocationValid, isListedLocationValid } =
    checkJobLocation(selectedJob);

  function checkJobAiSkillSet(skillSet) {
    if (!skillSet) {
      return null;
    }
    const hasSkills = Array.isArray(skillSet.skills);
    const hasSoftSkills = Array.isArray(skillSet.softSkills);
    const hasLanguages = Array.isArray(skillSet.languages);

    const skillsCount = hasSkills ? skillSet.skills.length : 0;
    const softSkillsCount = hasSoftSkills ? skillSet.softSkills.length : 0;
    const languagesCount = hasLanguages ? skillSet.languages.length : 0;

    const mandatoryKeysExist = hasSkills && hasSoftSkills;

    return {
      mandatoryKeysExist,
      skillsCount,
      softSkillsCount,
      languagesCount,
    };
  }

  const jobAiSkillSet = checkJobAiSkillSet(selectedJob.aiSkillSet);

  return (
    <ModalWrapper
      modalClassName={"modal-ux-wrapper"}
      padding={20}
      centered={false}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      onUnmountAction={() =>
        dispatch(fetchCustomerDetails({ subscription: null, discount: null }))
      }
    >
      {(loading || !selectedJob || (!selectedJob && !error)) && (
        <LoadingComponent />
      )}
      <Grid className="body-blue-text">
        <Grid.Row>
          <Grid.Column width={16}>
            <h2>
              Review Job{" "}
              <span className="body-blue-text">ID: {selectedJob.id}</span>
              <span> | </span>
              <span className="body-blue-text">
                REF: {selectedJob.refNumber}
              </span>
              <span> | </span>
              <span style={{ fontSize: 15 }}>
                Date: {format(selectedJob.dateCreated, "dd/MM/yyyy - HH:mm")}
              </span>
            </h2>
            <hr className="solid-divider" />
            {!loading && (
              <>
                <div>
                  <span className="body-bold-text">Employer details: </span>
                  <span>{employerDetails.displayName} / </span>
                  <CopyToClipboard text={employerDetails.email}>
                    <span className="clickable">
                      {employerDetails.email} /{" "}
                    </span>
                  </CopyToClipboard>{" "}
                  <span>{employerDetails.sibId} / </span>
                  <span>{employerDetails.mode}</span>
                </div>
                <div style={{ marginTop: 4 }}>
                  <span className="body-bold-text">Initialised: </span>
                  <span>{selectedJob.isInitialised ? "Yes" : "No"}</span>
                  {/* <span> | </span>
                  <span
                    className={
                      selectedJob.mode === HR_HEALTHCARE_MODE
                        ? "healthcare-background"
                        : ""
                    }
                  >
                    Mode: {selectedJob.mode}
                  </span> */}
                </div>
                <div style={{ marginTop: 4 }}>
                  <span className="body-bold-text">Paid: </span>
                  <span>
                    {selectedJob.isPaidFor ? "Yes" : "No"}{" "}
                    {selectedJob.isFree && " - Free"} |{" "}
                    <span className="body-bold-text">
                      Posted on subscription:{" "}
                    </span>
                    <span>{isSubscription ? "Yes" : "No"}</span>
                  </span>
                </div>

                {employerDetails.isRecruiter && <RecruiterTag inline={false} />}

                <div style={{ marginTop: 4, fontSize: 15 }}>
                  <span className="body-bold-text">
                    Company Id check {isCompanyId ? "PASS" : "FAIL"}:{" "}
                  </span>
                  <span style={{ color: isCompanyId ? "green" : "red" }}>
                    Job - {job.companyId} | Employer -{" "}
                    {employerDetails.companyId}
                  </span>
                </div>
              </>
            )}
            <Modal.Content
              scrolling
              style={{
                marginTop: 15,
                paddingTop: 10,
                borderTop: "1px solid #8d9cab",
                height: "50vh",
              }}
            >
              <div className="review-job-job-details body-blue-text">
                {selectedJob.companyLogoPhotoURL && (
                  <div
                    style={{
                      margin: "10px 0",
                      height: 180,
                      width: 300,
                      overflow: "hidden",
                      border: "1px solid #C2C5C7",
                      borderRadius: 10,
                    }}
                  >
                    <Image
                      src={selectedJob.companyLogoPhotoURL}
                      style={{ maxWidth: "100%", maxHeight: "100%" }}
                    />
                  </div>
                )}
                <div>
                  <span className="body-bold-text">Job title: </span>
                  <span>{selectedJob.title} </span>
                </div>
                <div>
                  <span className="body-bold-text">Company: </span>
                  <span>{selectedJob.company}</span>
                </div>
                <div>
                  <span className="body-bold-text">Job type: </span>
                  {/* <span>{getJobType(selectedJob.type)}</span> */}
                  <span>{selectedJob.type.toString()}</span>
                </div>
                {selectedJob.mode === HR_ALL_MODE && (
                  <div>
                    <span className="body-bold-text">Industry: </span>
                    <span>{getJobIndustry(selectedJob.industry)}</span>
                  </div>
                )}
                {selectedJob.mode === HR_HEALTHCARE_MODE && (
                  <div>
                    <span className="body-bold-text">Category: </span>
                    <span className={"healthcare"}>
                      {getHealthcareCategory(selectedJob.industry)}
                    </span>
                  </div>
                )}
                <div>
                  <span className="body-bold-text">Salary: </span>
                  <span>{selectedJob.salary.display}</span>
                </div>
                <div style={{ paddingRight: 40, marginTop: 15 }}>
                  <div className="body-bold-text underline-text job-description-title">
                    Job description{" "}
                  </div>
                  {typeof selectedJob.jobDescription?.url === "string" &&
                    selectedJob.jobDescription?.url !== "" && (
                      <div style={{ marginTop: 5 }}>
                        <span className="semi-bold">
                          {selectedJob.jobDescription.filename}
                        </span>
                        <a
                          style={{ marginLeft: 12 }}
                          className="text-link"
                          href={selectedJob.jobDescription.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download
                        </a>
                      </div>
                    )}
                  <div
                    className="rich-text-display-block"
                    dangerouslySetInnerHTML={{
                      __html: selectedJob.description,
                    }}
                  />
                </div>
              </div>
              <div className="body-blue-text">
                <div className="admin-job-modal-section">
                  <span>Contact Information</span>
                </div>
                <div>
                  <span className="body-bold-text">Name: </span>
                  <span>{selectedJob.contactName} </span>
                </div>
                <div>
                  <span className="body-bold-text">Email: </span>
                  <span>{selectedJob.contactEmail} </span>
                </div>
                <div>
                  <span className="body-bold-text">Phone number: </span>
                  <span>{selectedJob.phoneNumber} </span>
                </div>
                <div>
                  <span className="body-bold-text">Company website URL: </span>
                  <span>{selectedJob.contactWebsiteUrl?.url} </span>
                </div>
              </div>
              {selectedJob.isMultipleLocations && (
                <div style={{ margin: "35px 0 20px" }} className={"body-text"}>
                  {JSON.stringify(selectedJob.keyword, null, 2)}
                </div>
              )}
              <div style={{ marginTop: 10 }}>
                <span className="body-bold-text">Location type: </span>
                <span>{selectedJob.locationType} </span>
              </div>
              {selectedJob &&
                employerDetails &&
                selectedJob.locationType !== "Remote" && (
                  <div>
                    <div style={{ width: "88%" }}>
                      <hr className="solid-divider-light-grey" />
                    </div>
                    <Formik
                      initialValues={{ ...selectedJob.location }}
                      validationSchema={ADMIN_REVIEW_LOCATION_VALIDATION_SCHEMA}
                      onSubmit={async (
                        values,
                        { setSubmitting, setErrors }
                      ) => {
                        try {
                          await setJobLocationDetails(selectedJob, values);
                          setIsLocationLocked(true);
                          setSubmitting(true);
                        } catch (e) {
                          setErrors({ message: e.message });
                          setSubmitting(false);
                        }
                      }}
                    >
                      {({ isSubmitting, isValid, errors, values }) => (
                        <Form className="ui form" style={{ marginRight: 20 }}>
                          <div style={{ margin: "20px 0 30px 0" }}>
                            <div className="h3-text">Keywords</div>
                            <div className="admin-edit-field">
                              <MyKeywordTagInput
                                job={job}
                                adminKeywords={job.adminKeywords}
                              />
                            </div>
                          </div>
                          <div style={{ margin: "20px 0 30px 0" }}>
                            <div className="h3-text">
                              Search Term (optimised title)
                            </div>
                            <div className="admin-edit-field">
                              <MySingleFieldInput
                                placeholder={"Add search term"}
                                fieldValue={selectedJob.searchTerm || ""}
                                dbCollection={FIRESTORE_JOBS_COLLECTION}
                                id={selectedJob.id}
                                field={"searchTerm"}
                              />
                            </div>
                          </div>
                          <div style={{ margin: "20px 0 30px 0" }}>
                            <div className="h3-text">
                              Search recommend threshold
                            </div>
                            <div className="admin-edit-field">
                              <MySingleFieldInput
                                placeholder={"Add threshold"}
                                fieldValue={
                                  selectedJob.recommendSearchThreshold || ""
                                }
                                dbCollection={FIRESTORE_JOBS_COLLECTION}
                                id={selectedJob.id}
                                field={"recommendSearchThreshold"}
                                type={SINGLE_INPUT_NUMBER_TYPE}
                              />
                            </div>
                          </div>
                          {/* <div style={{ margin: "20px 0 30px 0" }}>
                          <div className="h3-text">
                            Search Term (optimised title)
                          </div>
                          <div className="admin-edit-field">
                            <MySingleFieldInput
                              placeholder={"Add search term"}
                              fieldValue={selectedJob.recommendAppliedThreshold || ""}
                              dbCollection={FIRESTORE_JOBS_COLLECTION}
                              id={selectedJob.id}
                              field={"searchTerm"}
                            />
                          </div>
                        </div> */}
                          <div style={{ width: "88%" }}>
                            <hr className="solid-divider-light-grey" />
                            <div style={{ marginTop: 20 }}>
                              <a
                                href="https://www.iban.com/country-codes"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Country Iso 2 codes
                              </a>
                            </div>
                          </div>
                          <div className="edit-job-job-details">
                            <div
                              className="h3-text"
                              style={{
                                marginBottom: 20,
                                color: job?.location?.address
                                  ? "#3A5CD8"
                                  : "red",
                              }}
                            >
                              Job Location{" "}
                              <span style={{ fontSize: 16, marginLeft: 10 }}>
                                <Icon
                                  name={isLocationValid ? "check" : "close"}
                                  color={isLocationValid ? "blue" : "red"}
                                />
                              </span>
                            </div>
                            <div className="title-space body-blue-text">
                              {selectedJob.location.latLng && (
                                <div>
                                  <span className="semi-bold">
                                    Job location:{" "}
                                  </span>
                                  <a
                                    className="text-link"
                                    href={`https://www.google.com/maps/@${selectedJob.location.latLng.lat},${selectedJob.location.latLng.lng},18z`}
                                    rel="noopener noreferrer"
                                    target={"_blank"}
                                  >
                                    {selectedJob.location.address}
                                  </a>
                                </div>
                              )}
                              <div style={{ margin: "10px 0" }}>
                                {selectedJob.locationType ?? ""}
                              </div>
                              <div>
                                <span className="semi-bold">
                                  Hidden location / Show city only:
                                </span>
                                <span>
                                  {selectedJob.isLocationHidden
                                    ? " Yes"
                                    : " No"}
                                </span>
                              </div>
                              <div>
                                <span className="semi-bold">
                                  Multiple locations:
                                </span>
                                <span>
                                  {selectedJob.isMultipleLocations
                                    ? " Yes"
                                    : " No"}
                                </span>
                              </div>
                            </div>
                            <Checkbox
                              checked={isLocationLocked}
                              label="Location locked"
                              style={{ marginRight: 10, paddingTop: 2 }}
                              onChange={(e, { checked }) =>
                                setIsLocationLocked(checked)
                              }
                            />
                            <div className="admin-edit-field">
                              Address*
                              <MyTextInput
                                className="form-input-field"
                                name="address"
                                placeholder="Address"
                                autoComplete="off"
                                isDisabled={isLocationLocked}
                              />
                            </div>
                            <div className="admin-edit-field">
                              Locality
                              <MyTextInput
                                className="form-input-field"
                                name="locality"
                                placeholder="Locality"
                                autoComplete="off"
                                isDisabled={isLocationLocked}
                              />
                            </div>
                            <div className="admin-edit-field">
                              Admin Area Level One*
                              <MyTextInput
                                className="form-input-field"
                                name="areaLevelOne"
                                placeholder="Area level one"
                                autoComplete="off"
                                isDisabled={isLocationLocked}
                              />
                            </div>
                            <div className="admin-edit-field">
                              Latitude (lat)*
                              <MyTextInput
                                className="form-input-field"
                                name="latLng.lat"
                                placeholder="lat"
                                autoComplete="off"
                                isDisabled={isLocationLocked}
                              />
                            </div>
                            <div className="admin-edit-field">
                              Longitude (lng)*
                              <MyTextInput
                                className="form-input-field"
                                name="latLng.lng"
                                placeholder="lng"
                                autoComplete="off"
                                isDisabled={isLocationLocked}
                              />
                            </div>
                            <div className="admin-edit-field">
                              Country Code*
                              <MyTextInput
                                className="form-input-field"
                                name="countryCode"
                                placeholder="Country Code"
                                autoComplete="off"
                                isDisabled={isLocationLocked}
                              />
                            </div>
                            <div className="admin-edit-field">
                              Country*
                              <MyTextInput
                                className="form-input-field"
                                name="country"
                                placeholder="Country"
                                autoComplete="off"
                                isDisabled={isLocationLocked}
                              />
                            </div>
                          </div>
                          <div style={{ marginTop: 24 }}>
                            <Button
                              className="overwrite-button cta-orange"
                              content={"Save & update"}
                              type={"submit"}
                              loading={isSubmitting}
                              disabled={
                                !isValid ||
                                isSubmitting ||
                                isEqual(selectedJob.location, values)
                              }
                              style={{ margin: "24px 4px 0" }}
                            />
                            <Button
                              className="overwrite-button cta-orange"
                              content={
                                isLocationSaved
                                  ? "Location saved"
                                  : "Save location"
                              }
                              loading={isLoading}
                              disabled={
                                isLoading ||
                                isLocationSaved ||
                                selectedJob.location.areaLevelOne ===
                                  ADMIN_NOTE ||
                                !isLocationValidForApproval(selectedJob)
                              }
                              type={"button"}
                              style={{ margin: "24px 4px 0" }}
                              onClick={handleSaveLocation}
                            />
                          </div>
                          {errors.message && (
                            <Label
                              basic
                              color="red"
                              style={{ marginBottom: 10 }}
                              content={errors.message}
                            />
                          )}
                          <br />
                          {selectedJob.isMultipleLocations && (
                            <div className={"body-text"}>
                              <h4>Multiple Locations</h4>
                              {selectedJob.multipleLocations.map(
                                (location, index) => (
                                  <div key={location.id}>
                                    {index + 1}: {location.address} <br />
                                    {JSON.stringify(location, null, 2)}
                                  </div>
                                )
                              )}
                            </div>
                          )}
                        </Form>
                      )}
                    </Formik>
                    <Formik
                      initialValues={{ ...selectedJob.listedLocation }}
                      validationSchema={
                        ADMIN_REVIEW_LISTED_LOCATION_VALIDATION_SCHEMA
                      }
                      onSubmit={async (
                        values,
                        { setSubmitting, setErrors }
                      ) => {
                        try {
                          await setJobListedLocationDetails(
                            selectedJob,
                            values
                          );
                          setIsListedLocationLocked(true);
                          setSubmitting(true);
                        } catch (e) {
                          setErrors({ message: e.message });
                          setSubmitting(false);
                        }
                      }}
                    >
                      {({ isSubmitting, isValid, errors, values }) => (
                        <Form className="ui form" style={{ marginRight: 20 }}>
                          <div className="edit-job-job-details">
                            <div
                              className="h3-text"
                              style={{
                                marginBottom: 20,
                                color: job?.listedLocation?.address
                                  ? "#3A5CD8"
                                  : "red",
                              }}
                            >
                              Job Listed Location
                              <span style={{ fontSize: 16, marginLeft: 10 }}>
                                <Icon
                                  name={
                                    isListedLocationValid ? "check" : "close"
                                  }
                                  color={isListedLocationValid ? "blue" : "red"}
                                />
                              </span>
                            </div>

                            <Checkbox
                              checked={isListedLocationLocked}
                              label="Listed Location locked"
                              style={{ marginRight: 10, paddingTop: 2 }}
                              onChange={(e, { checked }) =>
                                setIsListedLocationLocked(checked)
                              }
                            />
                            <div className="admin-edit-field">
                              Address*
                              <MyTextInput
                                className="form-input-field"
                                name="address"
                                placeholder="Address"
                                autoComplete="off"
                                isDisabled={isListedLocationLocked}
                              />
                            </div>
                            <div className="admin-edit-field">
                              City*
                              <MyTextInput
                                className="form-input-field"
                                name="city"
                                placeholder="City"
                                autoComplete="off"
                                isDisabled={isListedLocationLocked}
                              />
                            </div>
                            <div className="admin-edit-field">
                              Country Code*
                              <MyTextInput
                                className="form-input-field"
                                name="countryCode"
                                placeholder="Country Code"
                                autoComplete="off"
                                isDisabled={isListedLocationLocked}
                              />
                            </div>
                            <div className="admin-edit-field">
                              Country*
                              <MyTextInput
                                className="form-input-field"
                                name="country"
                                placeholder="Country"
                                autoComplete="off"
                                isDisabled={isListedLocationLocked}
                              />
                            </div>
                          </div>
                          <div style={{ marginTop: 24 }}>
                            <Button
                              className="overwrite-button cta-orange"
                              content={"Save & update"}
                              type={"submit"}
                              loading={isSubmitting}
                              disabled={
                                !isValid ||
                                isSubmitting ||
                                isEqual(selectedJob.listedLocation, values)
                              }
                              style={{ margin: "24px 4px 0" }}
                            />
                          </div>
                          {errors.message && (
                            <Label
                              basic
                              color="red"
                              style={{ marginBottom: 10 }}
                              content={errors.message}
                            />
                          )}
                        </Form>
                      )}
                    </Formik>
                  </div>
                )}
            </Modal.Content>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={8} verticalAlign={"middle"}>
            {reviewStatus.join(" | ")}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {!selectedJob.isClosed && selectedJob.isInitialised && (
            <Grid.Column width={8}>
              <div className="h2-text">Promote job</div>
              {isJobFeatured(job) && job.isInitialised && (
                <div className="featured-promotion-item">
                  Featured - {selectedJob.dateFeaturedExpiring.toString()}
                </div>
              )}
              {isJobSponsored(job) && job.isInitialised && (
                <div className="sponsored-promotion-item">
                  Sponsored - {selectedJob.dateSponsoredExpiring.toString()}
                </div>
              )}
              <Checkbox
                checked={isPromoteLocked}
                label="Locked"
                style={{ marginRight: 10, paddingTop: 2 }}
                onChange={(e, { checked }) => setIsPromoteLocked(checked)}
              />
              <Input
                iconPosition="left"
                disabled={isPromoteLocked}
                size="small"
                style={{ marginTop: 12 }}
                maxLength={"1"}
                value={promoteDays}
                onChange={(event, data) => setPromoteDays(data.value)}
              />
              <div style={{ marginTop: 11 }}>
                <Button
                  className="overwrite-button cta-orange side-by-side-button"
                  disabled={isPromoteLocked || promoteDays < 1}
                  content={"Feature"}
                  loading={isLoading}
                  onClick={() => handlePromoteJob("featured")}
                />
                <Button
                  className="overwrite-button cta-orange side-by-side-button"
                  disabled={isPromoteLocked || promoteDays < 1}
                  loading={isLoading}
                  content={"Sponsor"}
                  onClick={() => handlePromoteJob("sponsored")}
                />
              </div>
            </Grid.Column>
          )}
          <Grid.Column width={8}>
            <div className="h2-text" style={{ marginBottom: 10 }}>
              AI skill set
            </div>
            {jobAiSkillSet ? (
              <div>
                <div>Skills: {jobAiSkillSet.skillsCount}</div>
                <div>Soft skills: {jobAiSkillSet.softSkillsCount}</div>
                <div>Languages: {jobAiSkillSet.languagesCount}</div>
              </div>
            ) : (
              <div
                style={{
                  color: "red",
                }}
              >
                Check after initial approval
              </div>
            )}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <h4>Daily job alert type</h4>
            <Select
              clearable={true}
              options={DROP_DOWN_JOB_ALERTS}
              value={dailyNotificationType}
              onChange={(e, d) => setDailyNotificationType(d.value)}
              placeholder="Select daily alert type"
              disabled={selectedJob.isInitialised}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={11}>
            <div>
              If location was updated,{" "}
              <span className="semi-bold">Save & update</span> first before
              approving
            </div>
          </Grid.Column>
          <Grid.Column textAlign="right" width={5}>
            {isApprovingAction && (
              <div style={{ float: "right", marginRight: 20 }}>
                <Label basic color="grey" content="Waiting..." />
              </div>
            )}
            {selectedJob && (
              <Segment
                basic
                style={{
                  ...SEMANTIC_DIV,
                  paddingBottom: 12,
                  width: "fit-content",
                }}
                loading={loading}
              >
                <UxToggle
                  labelText={selectedJob.isApproved ? "Approved" : "Approve"}
                  handleClick={handleToggleButton}
                  checked={selectedJob.isApproved}
                  isDisabled={
                    (!selectedJob.isInitialised && !dailyNotificationType) ||
                    isApprovingAction ||
                    !selectedJob ||
                    (isRemote ? false : !isListedLocationValid) ||
                    !isDescriptionValid ||
                    selectedJob.isClosed ||
                    !isCompanyId
                  }
                />
              </Segment>
            )}
          </Grid.Column>
        </Grid.Row>
        {/* <Grid.Row>
          <div style={{ margin: "35px 0 20px" }} className={"body-text"}>
            {JSON.stringify(selectedJob, null, 2)}
          </div>
        </Grid.Row> */}
      </Grid>
    </ModalWrapper>
  );
}
